import { SvgIcon } from '@material-ui/core';
import { ReactComponent as pageError } from './pageError.svg';

export default function ErrorIcon(props) {
  return <SvgIcon {...props} component={pageError} viewBox="0 0 87 104" />;
}
